<template>

    <div class="postcard-item">
       <button v-if="userId == postcard.owner" class="icon small edit-postcard" @click="$emit('editpostcard', postcard)">
          <svg><use xlink:href="@/assets/svg/symbols.svg#edit-note"><title>Edit Postcard</title></use></svg>
        </button>

        <div v-if="showUser" class="attribution">from <router-link :to="'/postcards/by-user/' + postcard.owner" @click="$emit('attribselect')">{{userName(postcard.owner)}}</router-link></div>

        <div class="postcard-name">{{postcard.name}}</div>

        <div v-if="!!postcard.date" class="postcard-date">{{$moment(postcard.date.toDate()).format("l")}}</div>

        <img v-if="!!postcard.photos && !!postcard.photos[0]" :src="photoUrl(postcard.photos[0], 'medium')" class="pc-photo front" @click="$emit('photoselect', postcard.photos[0])"/>

        <img v-if="!!postcard.photos && !!postcard.photos[1]" :src="photoUrl(postcard.photos[1], 'medium')" class="pc-photo back" @click="$emit('photoselect', postcard.photos[1])"/>

        <div v-if="!!postcard.transcript && showTranscript" class="transcript">{{postcard.transcript}}</div>
    </div>

</template>

<script>
  import { mapGetters } from 'vuex'

  export default {

    name: "PhotoViewer",

    computed: {
      ...mapGetters('users', ['userId', 'userName']),
      ...mapGetters('photos', ['photoUrl'])
    },

    props: {
      postcard: Object,
      showTranscript: Boolean,
      showUser: Boolean
    }

  }
</script>

<style lang="scss" scoped>

  .postcard-item {
    position: relative;
    display: block;
    margin: 10px 0;
    padding: 10px;
    background-color: white;
    border-bottom: 2px solid #bbe6d6;

    .attribution {
      font-size: small;
      position: absolute;
      top: 12px;
      right: 50px;
    }

    .edit-postcard {
      position: absolute;
      top: 0;
      right: 10px;
    }

    .postcard-name {
      font-size: 1.5rem;
    }

    .postcard-date {
      margin-top: 10px;
    }

    .pc-photo {
      clear: both;
      display: block;
      margin: 10px auto;
      box-shadow: 2px 2px 5px grey;
      cursor: pointer;
    }

    .transcript {
      max-width: 600px;
      padding: 8px;
      border: solid 1px lightgrey;
      white-space: pre-wrap;
      margin: auto;
      margin-bottom: 15px;
    }
  }  
</style>